/**
 * 온리플 기능 소개 페이지 — 단일 소스 데이터
 *
 * 한 곳 수정하면 메인(/intro) + 카테고리 5개 페이지 모두 자동 반영됨.
 * 새 기능 추가 시: 해당 카테고리의 features 배열에 푸시 → 라우트/컴포넌트 변경 0
 *
 * SEO 메타: 카테고리·메인 모두 title/description/keywords 보유 (per-page Helmet 으로 적용)
 * adminLink: 로그인 후 진입 링크. 라우트 변경 시 함께 갱신 필요.
 * screenshot: src/images/intro/{value}.svg|png. 1차 SVG → 2차 디자이너 PNG 동일 파일명 교체.
 */

// 위젯 소개 카테고리의 실제 캡처 이미지 (썸네일 + 확대 보기)
import widgetBasic        from '../assets/widgwt_sample/basic.png';
import widgetGrid         from '../assets/widgwt_sample/grid.png';
import widgetInsight      from '../assets/widgwt_sample/review_insight.png';
import widgetBoard        from '../assets/widgwt_sample/board_review.png';
import widgetWriterQ      from '../assets/widgwt_sample/witer_q.png';
import widgetLiveReview   from '../assets/widgwt_sample/real_review.png';
import widgetLiveOrder    from '../assets/widgwt_sample/real_older_review.png';
import widgetAiKeyword    from '../assets/widgwt_sample/ai_review_keyword.png';
import widgetStarCount    from '../assets/widgwt_sample/category_count.png';

export const SITE_URL = 'https://ocadmin.onreview.co.kr';
export const SITE_NAME = '온리플';
export const OG_IMAGE = SITE_URL + '/og-image.png';
export const APPSTORE_URL = 'https://store.cafe24.com/kr/apps/23186';
export const TWITTER_HANDLE = '@onreple';

// 메인 페이지 핵심 6 가치
export const INTRO_HERO_FEATURES = [
  { icon: 'cpu',           title: 'AI 인사이트',         desc: '수많은 리뷰 속, AI가 핵심만 골라 한 줄로 들려드립니다.' },
  { icon: 'refresh-cw',    title: '카페24 자동 동기화',   desc: '쇼핑몰에 쌓이는 리뷰, 손 하나 까딱 안 해도 그대로 들어옵니다.' },
  { icon: 'grid',          title: '다양한 위젯',         desc: '메인부터 상세까지 — 원하는 자리에, 원하는 모양으로 자리잡습니다.' },
  { icon: 'send',          title: '작성 유도 자동화',    desc: '구매하신 분께 슬며시 권하는 알림톡과 마일리지로, 리뷰 수가 달라집니다.' },
  { icon: 'smartphone',    title: '모바일 완벽 지원',    desc: '어디서 보시든 흐트러짐 없이, 화면 크기에 맞춰 단정하게 펼쳐집니다.' },
  { icon: 'trending-up',   title: 'SEO 최적화',         desc: '리뷰가 검색에 닿고, 검색이 매출로 이어지도록 설계했습니다.' }
];

// 카테고리 5개 + 17 기능
export const INTRO_CATEGORIES = [
  // === 1. 리뷰 관리 (5 기능) ===
  {
    slug: 'review',
    title: '리뷰 관리',
    icon: 'message-square',
    summary: '여기저기 흩어진 리뷰, 이제 한자리에서 정리합니다. 동기화부터 필터, 답글, 옮겨오기까지 — 손 가는 일을 줄여드립니다.',
    seo: {
      title: '쇼핑몰 리뷰 솔루션 | 온리플',
      description: '카페24 리뷰 솔루션 — 자동 동기화, 스팸·욕설 필터, AI 답글, 대량 등록까지. 운영자의 일을 덜어주는 가장 빠른 길.',
      keywords: '리뷰 솔루션, 카페24 리뷰, 리뷰 관리, 리뷰 동기화, 리뷰 필터, 리뷰 답글, 리뷰 대량 등록'
    },
    features: [
      {
        id: 'sync', name: '카페24 리뷰 자동 동기화', icon: 'refresh-cw',
        desc: '카페24에 새 리뷰가 올라오는 순간, 온리플 화면에도 그대로 도착합니다.',
        bullets: [
          '오가는 리뷰도, 답글도 빠짐없이 양방향으로',
          '사진과 별점까지 한 번에 따라옵니다',
          '예전에 쌓아둔 리뷰도 한 번에 가져오기'
        ],
        screenshot: 'review-sync.svg',
        adminLink: '/installAndConnect'
      },
      {
        id: 'filter', name: '스팸·욕설 자동 필터', icon: 'shield',
        desc: '보여줘선 안 될 말은 살며시 가리고, 꼭 보여드릴 리뷰만 남깁니다.',
        bullets: [
          '차단할 단어와 대체할 표현, 직접 정해 보세요',
          '반복되는 스팸 패턴은 알아서 학습합니다',
          '애매한 건 관리자 검토함에 잠시 보관'
        ],
        screenshot: 'review-filter.svg',
        adminLink: '/reviewWriteConfig'
      },
      {
        id: 'reply', name: 'AI 답글 자동화', icon: 'message-circle',
        desc: '리뷰의 결을 읽고, 그에 맞는 답글을 AI가 먼저 써둡니다.',
        bullets: [
          '고마운 리뷰엔 따뜻하게, 아쉬운 리뷰엔 정중하게',
          '우리 브랜드의 말투를 그대로 학습',
          '마지막 한 번의 클릭이면 게시 완료'
        ],
        screenshot: 'review-reply.svg',
        adminLink: '/replyWriteConfig'
      },
      {
        id: 'bulk', name: '리뷰 대량 등록', icon: 'upload',
        desc: '다른 곳에 쌓아둔 리뷰, 엑셀 파일 한 장으로 옮겨드립니다.',
        bullets: [
          '바로 쓸 수 있는 엑셀 양식, 그대로 받아 가세요',
          '사진·별점·작성자까지 한꺼번에',
          '미리 검토하고 일괄 게시까지'
        ],
        screenshot: 'review-bulk.svg',
        adminLink: '/reviewBulkUpload'
      },
      {
        id: 'policy', name: '상품별 작성 정책', icon: 'sliders',
        desc: '상품마다 다른 조건, 상품마다 다른 규칙. 세세하게 다듬어 적용합니다.',
        bullets: [
          '상품 그룹별로 정책을 따로따로',
          '구매자만 작성, 누구나 작성 — 선택은 여러분 몫',
          '별점에 따라 자동으로 대기 처리'
        ],
        screenshot: 'review-policy.svg',
        adminLink: '/reviewWriteConfigByProduct'
      }
    ]
  },

  // === 2. 위젯 (9 기능) ===
  {
    slug: 'widget',
    title: '리뷰 위젯',
    icon: 'grid',
    summary: '어울리는 자리, 어울리는 모양. 페이지마다 알맞은 위젯으로 채워드립니다.',
    seo: {
      title: '쇼핑몰 리뷰 위젯 | 온리플',
      description: '기본 상품 상세, 그리드, AI 인사이트와 키워드, 게시판, 작성 유도, 실시간 리뷰·주문, 별점 요약까지. 카페24 쇼핑몰에 꼭 맞춘 9가지 리뷰 위젯.',
      keywords: '리뷰 위젯, 카페24 위젯, AI 인사이트, AI 리뷰 키워드, 실시간 리뷰, 별점 위젯, 리뷰 게시판, 리뷰 작성 유도'
    },
    features: [
      {
        id: 'productDetail', name: '기본 상품 상세 위젯', icon: 'package',
        desc: '상품 상세 페이지에 자연스럽게 녹아드는 표준 리뷰 영역.',
        bullets: [
          '별점·사진·작성자까지 한눈에',
          '정렬·필터로 원하는 리뷰만 쏙',
          '쇼핑몰 스킨과 어울리는 깔끔한 톤'
        ],
        screenshot: 'widget-product-detail.svg',
        thumbnail: widgetBasic,
        adminLink: '/reviewWriteConfig'
      },
      {
        id: 'grid', name: '그리드 위젯', icon: 'grid',
        desc: '메인·카테고리에서 시선을 사로잡는 그리드형 리뷰 모음.',
        bullets: [
          '카드·슬라이드·포토 갤러리 골라 쓰기',
          '사진 리뷰만 따로 모아 보기',
          '어떤 화면이든 자동으로 맞춤'
        ],
        screenshot: 'widget-grid.svg',
        thumbnail: widgetGrid,
        adminLink: '/widgetList'
      },
      {
        id: 'insight', name: '리뷰 인사이트 위젯', icon: 'zap',
        desc: 'AI가 정리한 한 줄 요약과 감성·핵심 주제를 카드로 보여줍니다.',
        bullets: [
          'AI 한 줄 요약 카드 노출',
          '긍·부정 감성 지표 한눈에',
          '여섯 가지 컬러 테마로 분위기 맞춤'
        ],
        screenshot: 'widget-ai-insight.svg',
        thumbnail: widgetInsight,
        adminLink: '/totalAiWidget'
      },
      {
        id: 'board', name: '리뷰 게시판 위젯', icon: 'list',
        desc: '게시판 형태로 풍성한 리뷰를 한 페이지에서 둘러보게 합니다.',
        bullets: [
          '페이지 이동 없이 무한 스크롤',
          '검색·정렬·별점 필터 기본 제공',
          '관리자 답글까지 함께 노출'
        ],
        screenshot: 'widget-board.svg',
        thumbnail: widgetBoard,
        adminLink: '/widgetByPage'
      },
      {
        id: 'writeInducer', name: '리뷰 작성 유도 위젯', icon: 'edit-3',
        desc: '구매하신 분께 "아직 리뷰가 비어 있어요"라고 살며시 권합니다.',
        bullets: [
          '내 주문 중 리뷰 가능한 상품만 모아 표시',
          '클릭 한 번에 작성 페이지로 연결',
          '마일리지·쿠폰 보상 자동 안내'
        ],
        screenshot: 'widget-write-inducer.svg',
        thumbnail: widgetWriterQ,
        adminLink: '/reviewableListWidget'
      },
      {
        id: 'liveReview', name: '실시간 리뷰 위젯', icon: 'activity',
        desc: '쇼핑몰을 둘러보는 분께 방금 막 들어온 리뷰를 보여드립니다.',
        bullets: [
          '새 리뷰가 위에서 자연스럽게 흐름',
          '메인·전체 페이지 어디든 배치',
          '클릭 시 해당 상품으로 바로 이동'
        ],
        screenshot: 'widget-live-review.svg',
        thumbnail: widgetLiveReview,
        adminLink: '/widgetList'
      },
      {
        id: 'liveOrder', name: '실시간 주문 위젯', icon: 'shopping-cart',
        desc: '지금 이 순간, 다른 분들의 주문 흐름이 신뢰를 만듭니다.',
        bullets: [
          '실시간 주문 알림 자동 표시',
          '인기 상품·카테고리 함께 강조',
          '상품 미리보기로 자연스러운 유입'
        ],
        screenshot: 'widget-live-order.svg',
        thumbnail: widgetLiveOrder,
        adminLink: '/widgetList'
      },
      {
        id: 'aiKeyword', name: 'AI 리뷰 키워드 위젯', icon: 'tag',
        desc: 'AI가 추출한 핵심 키워드를 칩으로 정리, 클릭하면 관련 리뷰만 노출됩니다.',
        bullets: [
          '키워드 클릭으로 인라인 필터링',
          '긍·부정 키워드를 한눈에 구분',
          '전체 리뷰 20건 이상부터 자동 생성'
        ],
        screenshot: 'widget-ai-keyword.svg',
        thumbnail: widgetAiKeyword,
        adminLink: '/reviewWriteConfig'
      },
      {
        id: 'starCount', name: '별점·리뷰수 위젯', icon: 'star',
        desc: '상품 리스트와 카드에 평균 별점·리뷰 수를 한 줄로 요약합니다.',
        bullets: [
          '메인·카테고리·검색 결과 어디든 적용',
          '별점 분포까지 툴팁으로 노출',
          '리뷰 수가 적을 땐 자연스럽게 숨김'
        ],
        screenshot: 'widget-star-count.svg',
        thumbnail: widgetStarCount,
        adminLink: '/widgetList'
      }
    ]
  },

  // === 3. 작성 유도 (3 기능) ===
  {
    slug: 'booster',
    title: '작성 유도',
    icon: 'send',
    summary: '구매하신 분께 슬며시 권하는 한마디, 그리고 작은 마일리지. 리뷰 수가 달라지기 시작합니다.',
    seo: {
      title: '리뷰 작성 유도 — 알림톡·마일리지 | 온리플',
      description: '구매하신 분께 알림톡으로 리뷰 작성을 권하고, 마일리지를 자동으로 얹어드립니다. 리뷰 수를 자연스럽게 늘리는 방법.',
      keywords: '리뷰 작성 유도, 알림톡, 카카오 알림톡, 마일리지, 적립금 자동 지급'
    },
    features: [
      {
        id: 'mileage', name: '마일리지 자동 지급', icon: 'gift',
        desc: '리뷰를 남기시면, 그 자리에서 적립금이 차곡차곡 쌓입니다.',
        bullets: [
          '별점과 사진에 따라 차등 지급',
          '카페24 적립금과 매끄럽게 연동',
          '지급 내역은 실시간으로 한눈에'
        ],
        screenshot: 'booster-mileage.svg',
        adminLink: '/mileageConfig'
      },
      {
        id: 'alimtalk', name: '알림톡 작성 유도', icon: 'message-circle',
        desc: '구매 후 며칠, 잊지 않으셨죠 — 알림톡이 슬며시 인사를 건넵니다.',
        bullets: [
          '보낼 시점과 반복 횟수, 자유롭게',
          '보내기 전 템플릿 미리보기',
          '발송 내역과 클릭률까지 한눈에'
        ],
        screenshot: 'booster-alimtalk.svg',
        adminLink: '/alimtalkSend'
      },
      {
        id: 'reviewableWidget', name: '미작성 구매자 위젯', icon: 'user-check',
        desc: '아직 리뷰가 없으시군요 — 마이페이지에서 부드럽게 권해드립니다.',
        bullets: [
          '마이페이지에 자동으로 자리잡습니다',
          '쓸 수 있는 상품, 한 화면에 모아서',
          '누르면 곧장 작성 화면으로'
        ],
        screenshot: 'booster-reviewable.svg',
        adminLink: '/widgetList'
      }
    ]
  },

  // === 4. AI 기능 (3 기능) ===
  {
    slug: 'ai',
    title: 'AI 기능',
    icon: 'cpu',
    summary: '수많은 리뷰 속 진짜 메시지, AI가 골라 들려드립니다. 키워드, 한 줄 요약, 그리고 한눈에 읽히는 분석까지.',
    seo: {
      title: 'AI 리뷰 분석·키워드 | 온리플',
      description: 'AI가 리뷰를 읽고 자주 언급된 키워드와 한 줄 요약을 자동으로 뽑아냅니다. 구매 결정에 닿는 진짜 인사이트.',
      keywords: 'AI 리뷰 분석, AI 키워드, 리뷰 요약, GPT 리뷰, 리뷰 인사이트'
    },
    features: [
      {
        id: 'aiKeyword', name: 'AI 리뷰 키워드', icon: 'tag',
        desc: '"디자인이 좋아요" 같이 사람 말투 그대로의 키워드를 뽑아냅니다.',
        bullets: [
          '딱딱하지 않은, 자연스러운 한마디',
          '키워드를 누르면 그 리뷰만 한 화면에',
          '메인·카테고리에도 띠 형태로 노출'
        ],
        screenshot: 'ai-keyword.svg',
        adminLink: '/aiKeywordList'
      },
      {
        id: 'aiSummary', name: 'AI 한줄 요약', icon: 'edit-3',
        desc: '전체 리뷰의 분위기, 강점, 그리고 아쉬움 — 한 줄로 정리해 드립니다.',
        bullets: [
          '구매 직전 마음을 움직이는 한 문장',
          '상품 상세 위젯 가장 위에 자동 노출',
          '매달 한 번 자동으로 새 단장'
        ],
        screenshot: 'ai-summary.svg',
        adminLink: '/reviewWriteConfig'
      },
      {
        id: 'aiAnalysis', name: 'AI 리뷰 분석 대시보드', icon: 'bar-chart-2',
        desc: '긍정과 부정, 칭찬과 아쉬움 — 한 화면에서 한눈에 읽힙니다.',
        bullets: [
          '품질·배송·가성비, 카테고리별로 따로',
          '대표 긍정·부정 리뷰는 자동으로 선정',
          '다음 개선 포인트까지 짚어드립니다'
        ],
        screenshot: 'ai-analysis.svg',
        adminLink: '/reviewInsight'
      }
    ]
  },

  // === 5. 콘텐츠 도구 (2 기능) ===
  {
    slug: 'design',
    title: '콘텐츠 도구',
    icon: 'image',
    summary: '쌓아둔 리뷰가 다시 빛나는 시간. 한 장의 이미지로, 한 편의 짧은 영상으로 다시 태어납니다.',
    seo: {
      title: '리뷰를 콘텐츠로 — 인스타 이미지·짧은 영상 | 온리플',
      description: '쇼핑몰 리뷰가 인스타그램 이미지와 릴스·숏츠 영상으로 다시 태어납니다. 디자이너 없이도 SNS 콘텐츠가 완성됩니다.',
      keywords: '리뷰 인스타 이미지, 리뷰 영상, 릴스 변환, 숏츠 변환, 리뷰 콘텐츠'
    },
    features: [
      {
        id: 'reviewToImage', name: '리뷰 → 인스타 이미지', icon: 'image',
        desc: '리뷰 한 줄이, 인스타그램 피드용 이미지로 곱게 다듬어집니다.',
        bullets: [
          '1:1, 9:16, 16:9 — 세 가지 비율 자동 생성',
          '브랜드의 색과 폰트를 그대로 입혀',
          'PNG로 받아서 그대로 SNS 업로드'
        ],
        screenshot: 'design-image.svg',
        adminLink: '/reviewToImage'
      },
      {
        id: 'reviewToVideo', name: '리뷰 → 짧은 영상 (MP4)', icon: 'video',
        desc: '여러 리뷰를 모아 릴스·숏츠용 짧은 영상으로 엮어드립니다.',
        bullets: [
          '세로·정사각·가로 — 어떤 SNS에든 어울리는 비율',
          '장면 전환과 배경음악은 AI가 알아서',
          'MP4로 저장 — 어느 플랫폼에서나 매끄럽게'
        ],
        screenshot: 'design-video.svg',
        adminLink: '/reviewToVideo'
      }
    ]
  }
];

// FAQ — 메인 페이지 노출
export const INTRO_FAQ = [
  {
    q: '카페24 외 다른 플랫폼도 지원하나요?',
    a: '지금은 카페24 공식 앱 연동을 우선으로 지원하고 있습니다. 다른 플랫폼 리뷰는 엑셀 파일 한 장으로 한 번에 옮겨오실 수 있습니다.'
  },
  {
    q: '설치는 얼마나 걸리나요?',
    a: '카페24 앱스토어에서 클릭 한 번이면 끝납니다. 위젯이 자리잡기까지 보통 5분이면 충분합니다.'
  },
  {
    q: 'AI 기능은 별도 비용인가요?',
    a: 'AI 키워드와 한 줄 요약, 답글 자동화까지 — 기본 플랜에 모두 담겨 있습니다. 사용량 제한 없이 마음껏 쓰세요.'
  },
  {
    q: '기존 리뷰는 어떻게 옮기나요?',
    a: '카페24 게시판 리뷰는 자동으로 따라옵니다. 외부 플랫폼 리뷰는 엑셀 일괄 업로드로 한 번에 옮기실 수 있습니다.'
  },
  {
    q: '무료 체험이 가능한가요?',
    a: '카페24 앱스토어에서 14일 동안 무료로 써보실 수 있습니다. 그 기간엔 모든 기능을 활짝 열어둡니다.'
  }
];

// JSON-LD SoftwareApplication
export const SOFTWARE_APP_LD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: '온리플',
  alternateName: 'Onreple',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'Review Management',
  operatingSystem: 'Web',
  description: '카페24 쇼핑몰 리뷰 솔루션 — AI 분석부터 자동 동기화, 위젯, 작성 유도까지 한 자리에서.',
  url: SITE_URL + '/intro',
  image: OG_IMAGE,
  inLanguage: 'ko-KR',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'KRW', description: '14일 무료 체험' },
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.5', reviewCount: '120', bestRating: '5', worstRating: '1' },
  publisher: { '@type': 'Organization', name: 'ONNOMADS', url: 'https://onnomad.co.kr' }
};

// Organization (브랜드 신뢰도 / 지식 그래프)
export const ORGANIZATION_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '온리플',
  alternateName: 'Onreple',
  url: SITE_URL + '/intro',
  logo: SITE_URL + '/logo_icon.svg',
  description: '카페24 쇼핑몰 리뷰 솔루션',
  sameAs: [
    APPSTORE_URL,
    'https://onnomad.co.kr'
  ]
};

// FAQPage — 메인 FAQ 5문항 (SERP rich snippet)
export const FAQ_PAGE_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: INTRO_FAQ.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a }
  }))
};
